import { memo } from "react"
import Box from '../../assets/icons/box.svg'

const Legends = (props) => {

    return (

        <span className="float-right" style={{ fontSize: "15px", fontWeight: "400", lineHeight: "1.5" }}>
            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="icofont icofont-map-pins f20"></i>&nbsp;&nbsp;View Route
            </button>
            {/* <button type="button" className="btn btn-default mybtn">
            <i className="fa fa-sitemap f20"></i>&nbsp;&nbsp;View Consignment Legs
        </button> */}
            {/* <button type="button" className="btn btn-default mybtn">
            <i className="fa fa-cubes" style={{ color: "#ff5370", fontSize: "17px" }}></i>&nbsp;&nbsp;Exception Flags
        </button> */}
            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="icofont icofont-clock-time" style={{ color: "#ff5370", fontSize: "20px" }}></i>&nbsp;&nbsp;Transit Delays
            </button>
            {/* <button type="button" className="btn btn-default mybtn">
            <i className="icofont icofont-social-google-map txt-danger" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;GPS Not Available
        </button>
        <button type="button" className="btn btn-default mybtn">
            <i className="icofont icofont-social-google-map txt-secondary" style={{ fontSize: "20px" }}></i>&nbsp;GPS Data Not Adequate
        </button> */}
            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="fa fa-tachometer darkblue" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;Overspeeding
            </button>
            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="icofont icofont-full-night txt-primary" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;Night Driving
            </button>
            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="icofont icofont-pause maroon" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;Stoppages
            </button>
            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="icofont icofont-truck-alt darkorange" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;Loading Delay
            </button>
            {props?.tabName?.value == "completed" || props?.tabName?.value == "all"  || props?.tabName?.value == "all_exim" || props?.tabName?.value == "completed_exim"?
                <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                    <i className="icofont icofont-vehicle-delivery-van mildgreen" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;Unloading Delay
                </button>
                : ""}
            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <img src={Box} title='Materials'></img>&nbsp;&nbsp;Materials
            </button>
            {props?.user?.role[0] == 'EXIM' ? <></> :<button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="fa fa-random purple" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;Deviated Routes
            </button>}
           {props?.user?.role[0] == 'EXIM' ? <></> :<button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="fa fa-circle" style={{ fontSize: "20px", color: "#F4E0AF" }}></i>&nbsp;&nbsp;Hot Loads
            </button>}
            {props?.user?.role[0] == 'EXIM' ? <></> :<button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="fa fa-circle" style={{ fontSize: "20px", color: "#ff90a3" }}></i>&nbsp;&nbsp;Invalid Driver No.
            </button>}
            {props?.user?.role[0] == 'EXIM' ? <></> :<button type="button" className="btn btn-default mybtn display-inflex-center-center">
                <i className="icofont icofont-file-text f18" style={{ fontSize: "20px", color: "#1e749c" }}></i>&nbsp;&nbsp;FO Updates
            </button>}
            
        </span>
    )
}
export default memo(Legends)